export default "__VITE_ASSET__BbDnV9Wl__"